<template>
<v-layout>
<v-calendar
  v-model="start"
  ref="calendar"
  :type="'month'"
  :start="start"
  :end="end"
  color="primary">
  <template v-slot:day="{ date }">
    <div v-if="$_getDailyReports(date)">
      <div
        v-for="report in $_getDailyReports(date)"
        :key="report.id + '-' + date"
        v-ripple
        :class="$_good(report) ? 'my-report' : 'my-report warning'"
        @click="dialogReport = true; selectedReport = report"
      >{{$_itemTitle(report)}}</div>
      <!--
      <v-menu
        v-for="report in $_getDailyReports(date)"
        :key="report.id + '-' + date"
        v-model="report.open"
        full-width
        offset-x>
        <template v-slot:activator="{ on }">
          <div
            v-if="!report.time"
            v-ripple
            :class="$_good(report) ? 'my-report' : 'my-report warning'"
            v-on="on"
          >{{$_itemTitle(report)}}</div>
        </template>
      </v-menu>
      -->
    </div>
  </template>
</v-calendar>
<v-dialog
  v-model="dialogReport"
  width="500">
  <report-card v-if="selectedReport" :report="selectedReport" />
</v-dialog>
</v-layout>
</template>

<script>
import moment from 'moment'
import ReportCard from './ReportCard'

export default {
  name: 'ReportMonthlyCalendar',
  components: {
    'report-card': ReportCard
  },
  props: {
    reports: {
      type: Array,
      default () {
        return []
      }
    },
    initStart: {
      type: String,
      default () {
        return moment().startOf('month').format('YYYY-MM')
      }
    }
  },
  data () {
    return {
      dialogReport: false,
      selectedReport: null,
      start: moment(this.initStart).startOf('month').format('YYYY-MM-DD'),
      end: moment(this.start).startOf('month').add(5, 'days').format('YYYY-MM-DD')
    }
  },
  computed: {
    // convert the list of reports into a map of lists keyed by date
    reportsMap () {
      const map = {}
      this.reports.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      return map
    }
  },
  methods: {
    $_getDailyReports (date) {
      return this.reportsMap[date]
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    $_itemTitle (report) {
      return (report.place ? report.place.name : '') +
        ' - ' + (report.charger ? report.charger.managementNumber : '')
    },
    $_good (report) {
      return report.checkResult || false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .my-report {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }

  .my-report.warning {
    background-color: orange;
    border: 1px solid orange;
  }
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportMonthlyCalendar.vue